<div class="container-xl">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (form()?.get('id').value && (Features.CompaniesDetailDelete | hasFeature)) {
            <button (click)="openDelete($event)" color="warning" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        }
    </div>
    @if (form()) {
        <div [formGroup]="form()" class="row gap-3">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3>
                            <b>Algemene gegevens</b>
                        </h3>
                    </div>
                    <div class="col">
                        <b>Naam</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="name" matInput name="name" placeholder="Naam">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Afkorting</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="short" matInput name="short" placeholder="Afkorting">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>E-mailadres</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="email" matInput name="email" placeholder="E-mailadres">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Ter attentie van</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="humres" matInput name="humres" placeholder="Ter attentie van">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3>
                            <b>Adres</b>
                        </h3>
                    </div>
                    <div class="col">
                        <b>Straat</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="street" matInput name="street" placeholder="Straat">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Huisnummer</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="number" matInput name="number" placeholder="Huisnummer" type="number">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Toevoeging</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="addition" matInput name="addition" placeholder="Toevoeging">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Stad</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="city" matInput name="city" placeholder="Stad">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Postcode</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="postal_code" matInput name="postal_code" placeholder="Postcode">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3>
                            <b>Azure</b>
                        </h3>
                    </div>
                    <div class="col">
                        <b>Project id</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="azure_project_id" matInput name="azure_project_id" placeholder="Project id" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Team id</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="azure_team_id" matInput name="azure_team_id" placeholder="Team id" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Beschrijving</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="azure_desc" matInput name="azure_desc" placeholder="Beschrijving" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3>
                            <b>Afas</b>
                        </h3>
                    </div>
                    <div class="col">
                        <b>AFAS Debiteur</b>
                        <div class="row">
                            <ng-select [items]="debtors()" [searchable]="true" bindLabel="debtorName" bindValue="debtorId" formControlName="afas_debtor_id"></ng-select>
                        </div>
                    </div>
                </div>
            </div>

            @if (Features.CompaniesSave | hasFeature) {
                <button (click)="save()" class="btn btn-primary" type="submit">Opslaan</button>
            }
        </div>
    }

    @if (form()?.get('id').value && (Features.CompaniesAzureitems | hasFeature) && (Features.CompaniesAzureteams | hasFeature)) {
        <div class="row mt-3">
            <div class="col-12">
                <h4>Azure integration</h4>
                @if (company?.azure_desc) {
                    <p>
                        This company is currently connected to {{company.azure_desc}}.
                        Use "Load Azure teams" to connect to another team.
                    </p>
                }

                <div class="row gap-2">
                    <button (click)="loadAzureItems()" class="btn btn-secondary" type="button">
                        Load Azure items
                    </button>

                    @if (azureItems()?.length) {
                        <pre class="py-2 json-codeblock">{{azureItems() | json}}</pre>
                    }
                </div>

                <div class="row gap-2 mt-3">
                    <button (click)="loadAzureTeams()" class="btn btn-secondary" type="button">
                        Load Azure teams
                    </button>

                    @if (azureTeams()?.length) {
                        <div class="col-12">
                            <h4>Choose an Azure team:</h4>
                            <div class="row gap-2">
                                @for (team of azureTeams(); track team.id) {
                                    <button (click)="connectAzure(team)" class="btn btn-outline-primary" type="button">
                                        {{team.name}} / {{team.projectName}}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</div>
